<template>
  <svg version="1.1"
       :id="wristwatch.id"
       class="sd-wristwatch"
       :class="{'display-only': forDisplayOnly}"
       xmlns="http://www.w3.org/2000/svg"
       xmlns:xlink="http://www.w3.org/1999/xlink"
       x="0px"
       y="0px"
       viewBox="0 0 144 220"
       enable-background="new 0 0 144 220"
       :preserveAspectRatio="forDisplayOnly ? 'xMidYMin meet' : 'xMidYMid meet'"
       xml:space="preserve">
    <g id="StemAndScrew">
      <linearGradient id="stemGradient_A-22" gradientUnits="userSpaceOnUse" x1="133.2609" y1="106.284" x2="128.7263" y2="114.1381">
        <stop  offset="0" style="stop-color:#F2F2F2"/>
        <stop  offset="1" style="stop-color:#C6C7C9"/>
      </linearGradient>
  		<rect x="122.1" y="109.525" fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" width="17.8" height="1.35"/>
      <g>
        <linearGradient id="screwGradient_A-22" gradientUnits="userSpaceOnUse" x1="133.8141" y1="106.415" x2="129.3734" y2="114.1066">
          <stop  offset="0" style="stop-color:#F2F2F2"/>
          <stop  offset="1" style="stop-color:#B2B3B5"/>
        </linearGradient>
        <polygon fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" points="134.1,113.9343
          133.5527,113.7296 133.05,113.9343 132.5027,113.7296 132,113.9343 131.4527,113.7296 130.95,113.9343 130.4028,113.7296
          129.9,113.9343 129.1,113.9343 129.1,106.5657 129.6472,106.7704 130.15,106.5657 130.6972,106.7704 131.2,106.5657
          131.7472,106.7704 132.25,106.5657 132.7972,106.7704 133.3,106.5657 133.8472,106.7704 134.1,106.5657 		"/>
          <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="129.1" y1="106.5657" x2="129.9" y2="113.9343"/>
          <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="130.15" y1="106.5657" x2="130.95" y2="113.9343"/>
          <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="131.2" y1="106.5657" x2="132" y2="113.9343"/>
          <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="132.25" y1="106.5657" x2="133.05" y2="113.9343"/>
          <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="129.6472" y1="106.7704" x2="130.4028" y2="113.7296"/>
          <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="130.6972" y1="106.7704" x2="131.4527" y2="113.7296"/>
          <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="131.7472" y1="106.7704" x2="132.5027" y2="113.7296"/>
          <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="132.7972" y1="106.7704" x2="133.5527" y2="113.7296"/>
          <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="133.8472" y1="106.7704" x2="134.1" y2="109.0985"/>
          <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="133.3" y1="106.5657" x2="134.1" y2="113.9343"/>
      </g>
    </g>
    <component
      v-if="strap"
      :is="strap.component"
      :data="strap">
    </component>
    <component
      v-if="pushers && pushers.length > 0"
      v-for="pusher in pushers"
      :key="pusher.id"
      :is="pusher.component"
      :pusherData.sync="pusher"
      :watchData.sync="wristwatch"
      :tutorialModeData.sync="tutorialMode"
      :bus="bus"
      @initialize-component="initializeComponent"
      @evaluate-component="evaluateComponent"
      @update-chrono-values="updateChronoValues"
      @clear-events-from-components="clearEventsFromComponents"
      @set-chrono-to-zero="setChronoToZero"
      @blink-circle="blinkCircle"
      @debounce-handset-highlight="debounceHandsetHighlight">
    </component>
    <component
      v-if="watchCase"
      :is="watchCase.component"
      :data="data">
    </component>
    <component
      v-if="calendars && calendars.length > 0"
      v-for="calendar in calendars"
      :key="calendar.id"
      :is="calendar.component"
      :data="{ calendar }"
      @initialize-component="initializeComponent">
    </component>
    <component
      v-if="dial"
      :is="dial.component"
      :data="dial">
    </component>
    <component
      v-if="hands && hands.length > 0"
      v-for="hand in hands"
      :key="hand.id"
      :is="hand.component"
      :data="{ hand, wristwatch }"
      @initialize-component="initializeComponent">
    </component>
    <component
      v-if="crown"
      :is="crown.component"
      :crownData.sync="crown"
      :watchData.sync="wristwatch"
      :tutorialModeData.sync="tutorialMode"
      @initialize-component="initializeComponent"
      @evaluate-component="evaluateComponent"
      @toggle-component="toggleComponent"
      @toggle-components="toggleComponents"
      @set-time="setTime"
      @set-day="setDay"
      @set-weekday="setWeekday"
      @update-time="updateTime"
      @set-component-event="setComponentEvent"
      @clear-events-from-components="clearEventsFromComponents"
      @highlight-circle="highlightCircle"
      @debounce-handset-highlight="debounceHandsetHighlight">
    </component>
  </svg>
</template>

<script>
import manual from '@/services/manualService';
import {
  debounce, difference, each, filter, hasIn, includes,
} from 'lodash';
import { Duration, DateTime } from 'luxon';
import SVG from 'svg.js';
import Vue from 'vue';

export default {
  name: 'sdWatch',
  props: ['data', 'tutorialModeData', 'tutorialStepData', 'displayOnly'],
  data() {
    return {
      manual,
      element: undefined,
      continueEvent: false,
      debounceHandsetHighlight: debounce(this.highlightComponents, 1000, { leading: true, maxWait: 0, trailing: true }),
      displayElements: [],
      unwatchTutorialStep: () => {},
      bus: new Vue(),
    };
  },
  computed: {
    wristwatch() {
      if (this.data) return this.data;
    },
    components() {
      if (this.wristwatch && this.wristwatch.components) return Object.values(this.wristwatch.components);
    },
    calendars() {
      if (this.wristwatch.components) return this.componentsFilter('calendar');
    },
    watchCase() {
      if (this.wristwatch.components) return this.componentsFind('watchCase');
    },
    crown() {
      if (this.wristwatch.components) return this.componentsFind('crown');
    },
    dial() {
      if (this.wristwatch.components) return this.componentsFind('dial');
    },
    hands() {
      if (this.wristwatch.components) return this.componentsFilter('hand');
    },
    pushers() {
      if (this.wristwatch.components) return this.componentsFilter('pusher');
    },
    strap() {
      if (this.wristwatch.components) return this.componentsFind('strap');
    },
    tutorialMode() {
      return this.tutorialModeData ? this.tutorialModeData : false;
    },
    tutorialStep() {
      if (this.tutorialStepData) return this.tutorialStepData;
    },
    forDisplayOnly() {
      return this.displayOnly || false;
    },
  },
  methods: {
    componentsFind(type) {
      return this.components.find(c => c.type === type);
    },
    componentsFilter(type) {
      return this.components.filter(c => c.type === type);
    },
    evaluateComponent(args) {
      this.$emit('evaluate-component', args);
    },
    activate() {
      this.initialize();
      if (this.wristwatch.chrono) {
        this.wristwatch.counterReset = {
          inProgress: false,
          value: 0,
        };
        this.setChronoToZero();
        this.updateChronoValues({ modelId: this.wristwatch.id, reset: true });
      }
      if (this.tutorialMode) {
        this.unwatchTutorialStep = this.$watch('tutorialStep', this.evaluateTutorialStep, { immediate: true });
      }
    },
    deactivate() {
      this.wristwatch.isRunning = false;
      clearTimeout(this.wristwatch.timeout);
      this.wristwatch.timeout = undefined;
      if (this.wristwatch.chrono) {
        this.wristwatch.chronoRunning = false;
        clearTimeout(this.wristwatch.chronoTimeout);
        this.wristwatch.chronoTimeout = undefined;
      }
      this.unwatchTutorialStep();
    },
    initialize() {
      const svg = SVG.adopt(this.element);
      svg.attr({ overflow: 'visible' });
    },
    initializeComponent(args) {
      const component = args.component ? args.component : undefined;
      const element = args.element ? args.element : undefined;
      element.oncontextmenu = (e) => {
        e.preventDefault();
        e.stopPropagation();
        return false;
      };
      // Set up wrapper element to animate when crown position changes
      if (!component.displayOnly) {
        if (component.wrapperId) {
          component.element = SVG.adopt(element.querySelector(`#${component.id}`));
          component.wrapperElement = SVG.adopt(element);
        } else {
          component.element = SVG.adopt(element);
        }
        if (component.element) this.setupHighlight(component.element);
        if (component.cx && component.cy) {
          component.element
            .attr({ cx: component.cx, cy: component.cy })
            .transform({ rotation: 0 });
          if (component.type === 'calendar') component.element.animate(120, '>')
        }
      }
      // Set up arrow elements for interaction
      if (component.arrowElements !== undefined) {
        each(component.arrowElements, (arrow) => {
          arrow.element = SVG.adopt(element.querySelector(`#${arrow.id}`));
          if (arrow.element) {
            arrow.element.mouseenter(() => this.highlightCircle({ self: arrow, condition: true }));
            arrow.element.mouseleave(() => this.highlightCircle({ self: arrow, condition: false }));
          }
        }, this);
      }
    },
    setLocalTime(val = undefined) {
      const local = val !== undefined ? val : DateTime.local();
      this.wristwatch.now = local;
      this.wristwatch.day = local.day;
      this.wristwatch.tomorrow = local.plus({ days: 1 }).day;
      this.wristwatch.weekday = local.weekday;
      return local;
    },
    setTime(self) {
      this.updateTimeValues({ minutes: 1 }, self.direction === 1);
    },
    updateTime() {
      if (this.wristwatch.isRunning) {
        // Update time each second
        this.updateTimeValues();
        this.wristwatch.timeout = setTimeout(() => { this.updateTime(); }, 1000);
      } else {
        clearTimeout(this.wristwatch.timeout);
        this.wristwatch.timeout = undefined;
      }
    },
    updateTimeValues(amount = { seconds: 1 }, forward = true) {
      this.wristwatch.now = forward
        ? this.wristwatch.now.plus(amount)
        : this.wristwatch.now.minus(amount);
      if (this.wristwatch.day === this.wristwatch.tomorrow) {
        this.setDay();
        this.setWeekday();
      }
      this.wristwatch.time.second = this.wristwatch.now.second * 6;
      this.wristwatch.time.minute = this.wristwatch.now.minute * 6 + this.wristwatch.time.second / 60;
      this.wristwatch.time.hour = ((this.wristwatch.now.hour % 12) / 12) * 360 + this.wristwatch.time.minute / 12;
      this.wristwatch.time.day = ((this.wristwatch.day + 3) / 31) * 360; // "+ 3" to offset illustration's disc default
      this.wristwatch.time.weekday = ((this.wristwatch.weekday + 6) / 7) * 360; // "+ 6" to offset illustration's disc default
      this.updateTimeComponents();
    },
    updateTimeComponents() {
      each(filter(this.wristwatch.components, (c, k) => includes(['hand', 'calendar'], c.type)), (component) => {
        switch (component.role) {
          case 'timeHour':
            component.element.transform({
              rotation: this.wristwatch.time.hour,
              cx: component.cx,
              cy: component.cy,
            });
            break;
          case 'timeMinute':
            component.element.transform({
              rotation: this.wristwatch.time.minute,
              cx: component.cx,
              cy: component.cy,
            });
            break;
          case 'timeSecond':
            component.element.transform({
              rotation: this.wristwatch.time.second,
              cx: component.cx,
              cy: component.cy,
            });
            break;
          case 'timeDay':
            component.element.transform({
              rotation: this.wristwatch.time.day,
              cx: component.cx,
              cy: component.cy,
            });
            break;
          case 'timeWeekday':
            component.element.transform({
              rotation: this.wristwatch.time.weekday,
              cx: component.cx,
              cy: component.cy,
            });
            break;
        }
      });
    },
    setDay() {
      this.wristwatch.day = (this.wristwatch.day % 31) + 1;
      this.wristwatch.tomorrow = (this.wristwatch.day % 31) + 1;
      this.updateTimeValues({days: 1})
      // TODO: Find a way to animate discs: 120ms, ease out
    },
    setWeekday() {
      this.wristwatch.weekday = (this.wristwatch.weekday % 7) + 1;
      this.updateTimeValues({days: 1})
    },
    updateChronoComponents(modelId, timeObj = this.wristwatch.chrono) {
      const hasPassedHalfHourMark = this.wristwatch.chronoNow.hours < 1 && this.wristwatch.chronoNow.minutes < 30;
      each(filter(this.wristwatch.components, (c, k) => c.type === 'hand', this), (component) => {
        switch (component.role) {
          case 'chronoHour':
            component.element.transform({
              rotation: modelId === 'a22'
                ? timeObj.hours
                : (hasPassedHalfHourMark
                  ? timeObj.milliseconds
                  : timeObj.hours),
              cx: component.cx,
              cy: component.cy,
            });
            break;
          case 'chronoMinute':
            component.element.transform({
              rotation: timeObj.minutes,
              cx: component.cx,
              cy: component.cy,
            });
            break;
          case 'chronoSecond':
            component.element.transform({
              rotation: timeObj.seconds,
              cx: component.cx,
              cy: component.cy,
            });
            break;
        }
      });
    },
    updateChronoValues(args) {
      const modelId = args.modelId ? args.modelId : undefined;
      const reset = args.reset ? args.reset : false;
      const displayInterval = args.displayInterval ? args.displayInterval : false;
      const amount = args.amount ? args.amount : { milliseconds: reset ? 0 : 100 };
      // Elapsed time should be stored for pausing, resuming, etc.
      // (To illustrate the use of crown and pusher functions)
      this.wristwatch.chronoNow = this.wristwatch.chronoNow.plus(amount).shiftTo('hours', 'minutes', 'seconds', 'milliseconds');
      this.wristwatch.chrono.milliseconds = (this.wristwatch.chronoNow.milliseconds / 100) * 36 % 360;
      this.wristwatch.chrono.seconds = this.wristwatch.chronoNow.seconds * 6 % 360;
      this.wristwatch.chrono.minutes = (this.wristwatch.chronoNow.minutes * 12) + (this.wristwatch.chrono.seconds / 30);
      this.wristwatch.chrono.hours = modelId === 'a22'
        ? (((this.wristwatch.chronoNow.hours % 12) / 12) * 360) + (this.wristwatch.chrono.minutes / 24)
        : (((this.wristwatch.chronoNow.hours % 10) / 10) * 360) + (this.wristwatch.chrono.minutes / 20);
      this.updateChronoComponents(modelId, displayInterval ? this.wristwatch.chrono.interval : this.wristwatch.chrono);
    },
    setChronoToZero() {
      this.wristwatch.chronoNow = Duration.fromObject(this.wristwatch.chrono.zero);
    },
    toggleComponent(args) {
      const component = args.component ? args.component : undefined;
      const condition = args.condition ? args.condition : undefined;
      if (condition) {
        component.element.show();
        component.element.animate(240).opacity(1);
      } else {
        component.element.animate(160).opacity(0);
        component.element.hide();
      }
    },
    toggleComponents(args) {
      const components = args.components ? args.components : undefined;
      const condition = args.condition ? args.condition : undefined;
      each(components, (component) => {
        if (condition) {
          component.element.show();
          component.element.animate(240).opacity(1);
        } else {
          component.element.animate(160).opacity(0);
          component.element.hide();
        }
      });
    },
    clearEventsFromComponents(args) {
      const components = args.components ? args.components : undefined;
      each(components, (component) => {
        component.element.off('mousedown');
        component.element.off('mouseup');
        component.element.off('click');
      }, this);
    },
    setComponentEvent(args) {
      const component = args.component ? args.component : undefined;
      const funcName = args.funcName ? args.funcName : undefined;
      const canHold = args.canHold ? args.canHold : false;
      const handset = args.handset ? args.handset : 'time';
      const func = args.func ? args.func : undefined;
      const funcArgs = args.funcArgs ? args.funcArgs : undefined;
      let timeout;
      // TODO: Here's where mobile devices aren't supported.
      component.element.mousedown(() => {
        if (handset !== false) this.debounceHandsetHighlight({ componentSet: handset });
        func && funcArgs ? func(funcArgs) : this[funcName](...component.clickParams);
        if (canHold) {
          timeout = setTimeout(() => {
            this.continueEvent = true;
            const quick = setInterval(() => {
              func && funcArgs ? func(funcArgs) : this[funcName](...component.clickParams);
              if (!this.continueEvent) clearInterval(quick);
            }, 16);
          }, 501);
        }
      });
      component.element.mouseup(() => {
        if (this.tutorialMode) {
          this.$emit('evaluate-component', this.wristwatch);
        }
        this.continueEvent = false;
        clearTimeout(timeout);
      });
      component.hasEvent = true;
    },
    toggleHover(self) {
      self.isHovered = !self.isHovered;
      this.highlightCircle({ self, condition: self.isHovered, state: 2 });
    },
    setupHighlight(element) {
      const bbox = element.bbox();
      const dim = bbox.w >= bbox.h ? bbox.w : bbox.h;
      element
        .circle(dim * 1.5)
        .translate(bbox.cx - (dim * 0.75), bbox.cy - (dim * 0.75)).back()
        .fill('#EDEBB9')
        .stroke('none')
        .opacity(0)
        .addClass('highlight')
        .style('mix-blend-mode', 'multiply');
      return element;
    },
    highlightCircle(args) {
      const self = args.self ? args.self : undefined;
      const condition = hasIn(args, 'condition') ? args.condition : undefined;
      const state = args.state ? args.state : 2;
      const color = args.color ? args.color : '#EDEBB9';
      const back = args.back ? args.back : false;
      // Highlight has three states:
      //   - 0:  Off
      //   - 1:  Highlight
      //   - 2:  Active (Hovered, updated, etc.)
      const circle = self.element.select('circle.highlight').fill(color);
      back ? circle.back() : circle.back();
      condition
        ? circle.animate(330).opacity(state * 0.5)
        : circle.animate(240).opacity(0);
    },
    blinkCircle(self) {
      const circle = self.element.select('circle.highlight');
      circle
        .animate({ duration: 490, delay: 190, ease: '>' }).opacity(1).fill('#D7C300')
        .animate(310, '<')
        .fill('#EDEBB9')
        .opacity(self.hoverState * 0.5);
    },
    highlightComponents(args) {
      const componentSet = args.componentSet ? args.componentSet : 'chrono';
      const color = args.color ? args.color : '#FED594';
      // Highlight specific elements when an event occurs
      const svgColor = new SVG.Color(color);
      const components = typeof componentSet === 'object'
        ? componentSet
        : filter(this.wristwatch.components, component => includes(component.role, componentSet));
      components.forEach((component) => {
        const children = component.element.children();
        children.forEach((child) => {
          const attrs = child.attr();
          child.animate(252, '>').attr({
            fill: attrs.fill && attrs.fill !== 'none'
              ? svgColor.morph(attrs.fill).at(0.33).toHex()
              : 'none',
            stroke: attrs.stroke && attrs.stroke !== 'none'
              ? svgColor.morph(attrs.stroke).at(0.33).toHex()
              : 'none',
            'stroke-width': attrs['stroke-width'] ? attrs['stroke-width'] : 0,
          }).animate(408, '<').attr({
            fill: attrs.fill ? attrs.fill : 'none',
            stroke: attrs.stroke ? attrs.stroke : 'none',
            'stroke-width': attrs['stroke-width'] ? attrs['stroke-width'] : 0,
          });
        });
      });
    },
    highlightDisplayElements(componentSet = 'chrono', color = '#FFC97A', onHold = false) {
      // color: #FFC97A
      // Highlight specific elements when an event occurs
      const svgColor = new SVG.Color(color);
      const components = typeof componentSet === 'object'
        ? componentSet
        : filter(this.wristwatch.components, component => includes(component.role, componentSet));
      components.forEach((component) => {
        const children = component.children
          ? component.children.filter(child => child.type !== 'circle')
          : component.element.children();
        if (onHold) {
          children.forEach((child) => {
            const attrs = child.attrs ? child.attrs : child.attr();
            const attrList = {};
            if (attrs.fill) attrList.fill = svgColor.morph(attrs.fill).at(0.166).toHex();
            if (attrs.stroke) attrList.stroke = svgColor.morph(attrs.stroke).at(0.166).toHex();
            if (attrs['stroke-width']) attrList['stroke-width'] = attrs['stroke-width'];
            child.animate(252, '>').attr(attrList);
          }, this);
        } else {
          children.forEach((child) => {
            const attrs = child.attrs ? child.attrs : child.attr();
            const attrList = {};
            if (attrs.fill) attrList.fill = attrs.fill;
            if (attrs.stroke) attrList.stroke = attrs.stroke;
            if (attrs['stroke-width']) attrList['stroke-width'] = attrs['stroke-width'];
            child.animate(408, '<').attr(attrList);
          });
        }
      });
    },
    evaluateTutorialStep(step) {
      const { crown, pusherA, pusherB } = this.wristwatch.components;
      const modelComponents = hasIn(this.wristwatch, 'chrono')
        ? [crown, crown.arrowElements[0], crown.arrowElements[1], pusherA, pusherB]
        : [crown, crown.arrowElements[0], crown.arrowElements[1]];

      if (this.tutorialMode) {
        if (step.expectation && hasIn(step.expectation, 'components')) {
          step.expectation.components.forEach((component) => { component.model = this.wristwatch.id; });
        }
        if (step.init && hasIn(step.init, 'time')) {
          this.setLocalTime(step.init.time.value);
          if (hasIn(step.init, 'time.isRunning')) {
            this.wristwatch.isRunning = step.init.time.isRunning;
          }
        }
        if (step.init && hasIn(step.init, 'day')) {
          this.wristwatch.day = step.init.day.value
          this.wristwatch.tomorrow = (step.init.day.value % 31) + 1
        }
        if (step.init && hasIn(step.init, 'weekday')) {
          this.wristwatch.weekday = step.init.weekday.value
        }
        if (step.init && hasIn(step.init, 'components')) {
          step.init.components.forEach((stepInitComponent) => { stepInitComponent.model = this.wristwatch.id; });
          const tutorialStepInitComponents = modelComponents.filter(modelComponent => step.init.components.find(stepInitComponent => stepInitComponent.id === modelComponent.id));
          const unusedTutorialStepInitComponents = difference(modelComponents, tutorialStepInitComponents);
          tutorialStepInitComponents.forEach((stepInitComponent) => {
            stepInitComponent.hoverState = 1;
            this.blinkCircle(stepInitComponent, 1);
            stepInitComponent.element.removeClass('disabled');
          });
          unusedTutorialStepInitComponents.forEach((stepInitComponent) => {
            stepInitComponent.hoverState = 0;
            stepInitComponent.element.addClass('disabled');
            this.highlightCircle({ self: stepInitComponent, condition: false, state: 0 });
          });
        }
        if (step.init && hasIn(this.wristwatch, 'chrono') && hasIn(step.init, 'chrono')) {
          this.wristwatch.chronoRunning = step.init.chrono.isRunning;
          if (step.init.chrono.isRunning === true) {
            this.wristwatch.components.pusherA.value = this.wristwatch.components.pusherB.value = 0;
            this.bus.$emit('start-chrono', this.wristwatch.components.pusherA);
          } else {
            // Shouldn't get pressed — should just stop
            this.wristwatch.components.pusherA.value = this.wristwatch.components.pusherB.value = 0;
            this.setChronoToZero();
            this.updateChronoValues({ modelId: this.wristwatch.id, reset: true });
          }
        }
        if (step.init && hasIn(this.wristwatch, 'chrono') && hasIn(step.init, 'chronoZero')) {
          Object.keys(step.init.chronoZero).map((key) => {
            this.wristwatch.chrono.zero[key] = step.init.chronoZero[key];
          });
          this.setChronoToZero();
          this.updateChronoValues({ modelId: this.wristwatch.id, reset: true });
        }
        if (this.displayElements.length) {
          this.displayElements.forEach((displayElement) => {
            // Clear highlight(s) from previous step's displayElements
            this.highlightDisplayElements([this.wristwatch.components[displayElement.role]], '#FFC325', false);
            this.highlightCircle({
              self: this.wristwatch.components[displayElement.role], condition: false, state: 0, color: '#595352', back: false,
            });
          }, this);
        }
        if (step.init && step.init.displayElements) {
          step.init.displayElements.forEach((displayElement) => {
            displayElement.model = this.wristwatch.id;
            Vue.set(this.wristwatch.components[displayElement.role], 'children', this.wristwatch.components[displayElement.role].element.children());
            this.wristwatch.components[displayElement.role].children.forEach((child) => {
              Vue.set(child, 'attrs', child.attr());
            });
            this.highlightDisplayElements([this.wristwatch.components[displayElement.role]], '#FFC325', true);
            this.highlightCircle({
              self: this.wristwatch.components[displayElement.role], condition: true, state: 2, color: '#595352', back: true,
            });
          }, this);
          this.displayElements = step.init.displayElements;
        }
      } else {
        // Disable component highlighting
        modelComponents.forEach((modelComponent) => {
          modelComponent.hoverState = 0;
          modelComponent.element.removeClass('disabled');
          this.highlightCircle({ self: modelComponent, condition: false, state: 0 });
        });
      }
    },
  },
  created() {
    this.setLocalTime();
  },
  mounted() {
    this.element = this.$el;
    this.activate();
    if (this.wristwatch.isRunning) {
      clearTimeout(this.wristwatch.timeout);
      this.updateTime();
    }
  },
  beforeDestroy() {
    this.deactivate();
  },
};
</script>

<style lang="scss" scoped>
  @import './../../styles/layout';
  .sd-wristwatch {
    display: block;
    width: 100%;
    height: auto;
    @media all and (min-width: $sd-vw_sm) {
      padding: 5ch;
    }
  }
</style>
